import { render, staticRenderFns } from "./cardElement.vue?vue&type=template&id=2f85d572&"
import script from "./cardElement.vue?vue&type=script&lang=js&"
export * from "./cardElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cardElement.vue"
export default component.exports